<template>
  <div>
    <div class="  selectcard-hover items-center ">
      <p class="font-semibold text-lg mb-2">Manage Seller Review</p>
      <el-table
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
        :data="ReviewData"
      >
        <el-table-column label="ID" prop="id" min-width="120px" sortable>
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{ row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="CustomerEmail"
          min-width="150px"
          prop="customeremail"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{ row.customeremail }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Rating"
          min-width="120px"
          prop="rating"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{ row.rating }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Comment"
          min-width="180px"
          prop="comment"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{ row.comment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Date" min-width="150px" prop="date" sortable>
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{ row.date }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Status"
          min-width="180px"
          prop="status"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{ row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Action"
          min-width="120px"
          prop="action"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{ row.action }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import ReviewData from "./ReviewData";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      ReviewData
    };
  }
};
</script>
